import { useEffect, useState } from "react";
import './PageRegister.scss';
import useMain from "../../common/MainContext";
import LoginData from "../../repository/LoginData";
import FormRegisterUser from "../../components/forms/registerUser/FormRegisterUser";
import FormBorder from "../../components/formBorder/FormBorder";

export default function PageRegister(props) {
    //const { setLanguage, searchParams, setSearchParams } = useMain();
    const { setLanguage } = useMain();
    const [regLoginData, setRegLoginData] = useState();

    useEffect(() => {
        debugger
        const urlLoginData = new LoginData(props.currentSearchParams.token);

        if (!(urlLoginData.tokenData.token.type === 'REGISTRATION' && urlLoginData.tokenData.user.id)) {
            setRegLoginData({});
            return;
        }

        setLanguage(() => (setRegLoginData.language || 'en'));
        setRegLoginData(urlLoginData);
    }, [])

    return (
        <div className="page-register fullpage">
            <FormBorder
                form={
                    <FormRegisterUser
                        regLoginData={regLoginData}
                    //callback={() => setSearchParams({})}
                    />
                }
            />
        </div>
    )
}
